import SubKeywordCount from './subKeywordCount'
export default SubKeywordCount
